import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { catchError, switchMap, filter, take, tap } from 'rxjs/operators';
import { AuthTokenService } from '../../services/auth-token.service';


@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(private authService: AuthTokenService,
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
     if (request.headers.get('skipInterceptor') === 'true') {
    const cleanReq = request.clone({
      headers: request.headers.delete('skipInterceptor')
    });
    return next.handle(cleanReq);
  }
    const token: any = localStorage.getItem('token');

    if (token) {
      request = this.addTokenToRequest(request, token);
    }

    return next.handle(request).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          // success response
        }
      }),
      catchError((error: any) => {
        if (error instanceof HttpErrorResponse && error.status === 401) {
          if (!this.isRefreshing) {
            this.isRefreshing = true;
            this.refreshTokenSubject.next(null);

            return this.authService.refreshToken().pipe(
              switchMap((newToken: any) => {
                this.isRefreshing = false;
                localStorage.setItem('token', newToken); 
                this.refreshTokenSubject.next(newToken);

                // Retry original request with new token
                return next.handle(this.addTokenToRequest(request, newToken));
              }),
              catchError((refreshError: any) => {
                this.isRefreshing = false;
                localStorage.clear();
                window.location.href = '/login';
                return throwError(() => refreshError);
              })
            );
          } else {
            // Wait until new token is set, then retry
            return this.refreshTokenSubject.pipe(
              filter(token => token !== null),
              take(1),
              switchMap((newToken) => {
                return next.handle(this.addTokenToRequest(request, newToken));
              })
            );
          }
        } else {
          return throwError(() => error);
        }
      })
    );
  }

  private addTokenToRequest(request: HttpRequest<any>, token: string) {
    return request.clone({
      setHeaders: { Authorization: `Bearer ${token}` }
    });
  }


  // private showLoader(): void {
  //   this.sharedService.showHideSpinner(true);
  // }

  // private hideLoader(): void {
  //   this.sharedService.showHideSpinner(false);
  // }
}
